import { render } from "./WorkflowNameIcon.vue?vue&type=template&id=ed172320"
import script from "./WorkflowNameIcon.vue?vue&type=script&lang=js"
export * from "./WorkflowNameIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__